import { CONFIG_TYPES } from '@/constants/featureConfig'
import { ConfigValue } from '@/models/featureConfig'

export const transformValue = ({ value, type }: ConfigValue) => {
  switch (type) {
    case CONFIG_TYPES.INTEGER:
      return Number(value)

    case CONFIG_TYPES.BOOLEAN:
      return value === 'true'

    case CONFIG_TYPES.LIST:
      return value.split(' ').join('').split(',')

    default:
      return value
  }
}
